let type = 1; // 0测试 1正式

export let baseURL =
  type == 0
    ? "http://127.0.0.1:8808/cvcloud-boot"
    : "https://www.gdyapp.com/eshop-boot/";
